var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, DIV } from '../../../lib/dom';
import { OrangeButton } from '../../../lib/components/Button/Button';
import { PHRASES, t } from '../../../translate';
import { ELEMENT } from '../../../lib/dom/ELEMENT';
import { USE_ROTATE } from '../../../app/const/features';
import './NextButton.less';
var NextButton = /** @class */ (function (_super) {
    __extends(NextButton, _super);
    function NextButton(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'NextButton';
        _this.onClick = function () {
            if (_this.props.onClick) {
                _this.props.onClick();
            }
        };
        _this.el = new DIV('NextButton-w', [
            new DIV('NextButton-header', [t(PHRASES.You_are_ready_to_play)]),
            new DIV('NextButton-content', [
                new ELEMENT('ul', {}, [
                    new ELEMENT('li', {}, [t(PHRASES.MOVE_SHAPES_TO_GOOD_SCORE)]),
                    new ELEMENT('li', {}, [t(PHRASES.OCCUPIED_CELLS_ARE_VACATED)]),
                    USE_ROTATE ? new ELEMENT('li', {}, [t(PHRASES.SHAPES_CAN_BE_TURNED)]) : null,
                ]),
            ]),
            new OrangeButton({ className: 'AnimatedButton', onClick: _this.onClick }, [t(PHRASES.Play)]),
        ]);
        return _this;
    }
    NextButton.prototype.render = function () {
        return this.el.valueOf();
    };
    return NextButton;
}(Component));
export { NextButton };
